
export function init() {
  $(document).ready(() => {
    const favouriteBtn = document.querySelectorAll('.favourite');
    const addToWishlistBtn = $('.add-to-wishlist');

    addToWishlistBtn.on('click', () => {
      const productId = $('.product-id').val();
      const isActive = $('.add-to-wishlist').data('active');
      const wishlistTotal = $('.wishlist-total');
      const data = {
        product_id: productId,
      }

      if (isActive) {
        axios.delete('/remove-item-to-wishlist', {
          data: data
        })
          .then((response) => {
            addToWishlistBtn.removeClass('active-favourite');
            wishlistTotal.html(response.data.totalItem);
            addToWishlistBtn.data('active', false);
            toastr["success"](response.data.message);
          })
          .catch(error => {
            toastr["info"](error.message);
          });
      } else {
        axios.post('/add-to-wishlist', data)
          .then((response) => {
            addToWishlistBtn.addClass('active-favourite');
            addToWishlistBtn.data('active', true);
            wishlistTotal.html(response.data.totalItem);
            toastr["success"](response.data.message);
          })
          .catch(error => {
            toastr["info"](error.message);
          });
      }
    });

    favouriteBtn.forEach((button, index) => {
      button.addEventListener('click', () => {
        const productId = $(`.product-${index}`).val();
        const isActive = $(button).data('active');
        const heartIcon = $(`.heart-icon${index}`);
        const wishlistTotal = $('.wishlist-total');

        const data = {
          product_id: productId,
        }

        if (isActive) {
          axios.delete('/remove-item-to-wishlist', {
            data: data
          })
            .then((response) => {
              heartIcon.removeClass('active-favourite');
              wishlistTotal.html(response.data.totalItem);
              $(button).data('active', false);
              toastr["success"](response.data.message);
            })
            .catch(error => {
              toastr["info"](error.message);
            });
        } else {
          axios.post('/add-to-wishlist', data)
            .then((response) => {
              heartIcon.addClass('active-favourite');
              wishlistTotal.html(response.data.totalItem);
              $(button).data('active', true);
              toastr["success"](response.data.message);
            })
            .catch(error => {
              toastr["info"](error.message);
            });
        }
      });
    });
  });
}
